<template>
    <div class="site-system page-info">
        <heading title="System Status" tag="site-status-title"/>
        <div v-html="phpinfo"/>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'SiteSystem',
    data () {
        return {
            phpinfo: null
        }
    },
    methods: {},
    mounted () {
        this.$api.loadSystem()
            .then((response) => {
                this.phpinfo = response.body
            })
    }
})
</script>
